import React, {Component} from 'react';
import AutoComplete from 'react-google-autocomplete';
import {addIdToGoogleAutocomplete} from 'helpers/googleAutocomplete';

class GoogleMapsAutoComplete extends Component {
    componentDidMount() {
        addIdToGoogleAutocomplete('pac-container-chat-bot');
    }

    componentWillUnmount() {
        const pac = document.getElementsByClassName('pac-container')[0];
        pac && pac.parentNode.removeChild(pac);
    }

    submitAddress(address) {
        this.props.onAddressSelected(this.props.message, address);
    }

    render(){
        return (
            <div id={this.props.id} className="message-input-container message-google-maps-auto-complete absolute-position input-root">
                <div>
                    <AutoComplete
                        className="input-google-maps-auto-complete"
                        placeholder={this.props.message.text}
                        onPlaceSelected={(address) => {
                            this.submitAddress(address);
                        }}
                        onFocus={this.props.onFocus}
                        onBlur={this.props.onBlur}
                        types={['address']}
                        componentRestrictions={{country: "us"}} />
                </div>
            </div>
        );
    }
}

export default GoogleMapsAutoComplete;